import dallasLogo from '../assets/dallas-logo.png';

const LOGO_SRC_MAP = {
  'dallas-logo': dallasLogo,
  '/dallas-logo.png': dallasLogo,
  '/Dallas Logo.png': dallasLogo
};

/** Resolve logo paths for bundled assets and public folder files. */
export function resolveEventLogoSrc(src) {
  if (LOGO_SRC_MAP[src]) {
    return LOGO_SRC_MAP[src];
  }

  const publicUrl = process.env.PUBLIC_URL || '';
  return `${publicUrl}${encodeURI(src)}`;
}
